/**
 * Países que puede representar un jugador: todos los códigos ISO 3166-1
 * alfa-2 (249) más Kosovo (XK, código de uso común). Para cada uno, los 1 o 2
 * colores principales de su bandera, que se usan para el uniforme.
 *
 * La bandera se muestra como emoji (letras regionales a partir del código);
 * el nombre se obtiene en español con `Intl.DisplayNames` (cliente).
 * Tabla documentada en `docs/PAISES.md`.
 */

/** Código → "color1,color2" de la bandera (el primero es el de la camiseta). */
const FLAG_COLORS_RAW = `
AD:#10069f,#fedf00 AE:#00732f,#ff0000 AF:#007a36,#be0000 AG:#ce1126,#000000 AI:#012169,#ffffff
AL:#e41e20,#000000 AM:#d90012,#0033a0 AO:#cc092f,#000000 AQ:#3a7dce,#ffffff AR:#74acdf,#ffffff
AS:#002b7f,#bf0a30 AT:#ed2939,#ffffff AU:#012169,#e4002b AW:#418fde,#fbe122 AX:#0064ad,#ffd300
AZ:#0092bc,#00af66 BA:#002395,#fecb00 BB:#00267f,#ffc726 BD:#006a4e,#f42a41 BE:#ef3340,#fdda24
BF:#ef2b2d,#009e49 BG:#00966e,#d62612 BH:#ce1126,#ffffff BI:#ce1126,#1eb53a BJ:#008751,#fcd116
BL:#0055a4,#ef4135 BM:#c8102e,#012169 BN:#f7e017,#000000 BO:#007934,#f9e300 BQ:#012a87,#f9e814
BR:#ffdf00,#009c3b BS:#00abc9,#fae042 BT:#ffd520,#ff4e12 BV:#ba0c2f,#00205b BW:#75aadb,#000000
BY:#c8313e,#4aa657 BZ:#003f87,#ce1126 CA:#ff0000,#ffffff CC:#008000,#ffe000 CD:#007fff,#f7d618
CF:#003082,#ffce00 CG:#009543,#fbde4a CH:#ff0000,#ffffff CI:#f77f00,#009e60 CK:#012169,#ffffff
CL:#d52b1e,#0039a6 CM:#007a5e,#ce1126 CN:#ee1c25,#ffff00 CO:#fcd116,#003893 CR:#ce1126,#002b7f
CU:#002a8f,#cf142b CV:#003893,#cf2027 CW:#002b7f,#f9e814 CX:#0021ad,#1c8a42 CY:#ffffff,#d57800
CZ:#11457e,#d7141a DE:#000000,#ffce00 DJ:#6ab2e7,#12ad2b DK:#c8102e,#ffffff DM:#006b3f,#fcd116
DO:#002d62,#ce1126 DZ:#006233,#ffffff EC:#ffd100,#034ea2 EE:#0072ce,#000000 EG:#ce1126,#000000
EH:#000000,#007a3d ER:#12ad2b,#ea0437 ES:#aa151b,#f1bf00 ET:#078930,#fcdd09 FI:#ffffff,#002f6c
FJ:#68bfe5,#012169 FK:#012169,#ffffff FM:#75b2dd,#ffffff FO:#ffffff,#0065bd FR:#0055a4,#ef4135
GA:#009e60,#fcd116 GB:#012169,#c8102e GD:#ce1126,#fcd116 GE:#ffffff,#ff0000 GF:#0055a4,#ef4135
GG:#ffffff,#e8112d GH:#ce1126,#fcd116 GI:#ffffff,#da000c GL:#ffffff,#d00c33 GM:#ce1126,#0c1c8c
GN:#ce1126,#fcd116 GP:#0055a4,#ef4135 GQ:#3e9a00,#e32118 GR:#0d5eaf,#ffffff GS:#012169,#c8102e
GT:#4997d0,#ffffff GU:#00297b,#c62139 GW:#ce1126,#fcd116 GY:#009e49,#fcd116 HK:#de2910,#ffffff
HM:#012169,#e4002b HN:#0073cf,#ffffff HR:#ff0000,#ffffff HT:#00209f,#d21034 HU:#ce2939,#477050
ID:#ff0000,#ffffff IE:#169b62,#ff883e IL:#ffffff,#0038b8 IM:#cf142b,#ffffff IN:#ff9933,#138808
IO:#012169,#ffffff IQ:#ce1126,#000000 IR:#239f40,#da0000 IS:#02529c,#dc1e35 IT:#009246,#ce2b37
JE:#ffffff,#df112d JM:#009b3a,#fed100 JO:#000000,#007a3d JP:#ffffff,#bc002d KE:#bb0000,#006600
KG:#e8112d,#ffef00 KH:#032ea1,#e00025 KI:#ce1126,#003f87 KM:#3a75c4,#3d8e33 KN:#009e49,#ce1126
KP:#024fa2,#ed1c27 KR:#ffffff,#cd2e3a KW:#007a3d,#ce1126 KY:#012169,#c8102e KZ:#00afca,#fec50c
LA:#ce1126,#002868 LB:#ed1c24,#00a651 LC:#65cfff,#fcd116 LI:#002b7f,#ce1126 LK:#8d153a,#ffb700
LR:#bf0a30,#002868 LS:#00209f,#009543 LT:#fdb913,#006a44 LU:#ed2939,#00a1de LV:#9e3039,#ffffff
LY:#e70013,#239e46 MA:#c1272d,#006233 MC:#ce1126,#ffffff MD:#0046ae,#ffd200 ME:#c40308,#d4af3a
MF:#0055a4,#ef4135 MG:#fc3d32,#007e3a MH:#003893,#dd7500 MK:#d20000,#ffe600 ML:#14b53a,#fcd116
MM:#fecb00,#34b233 MN:#c4272f,#015197 MO:#00785e,#ffffff MP:#0071bc,#ffffff MQ:#0055a4,#ef4135
MR:#006233,#ffc400 MS:#012169,#ffffff MT:#ffffff,#cf142b MU:#ea2839,#1a206d MV:#d21034,#007e3a
MW:#ce1126,#339e35 MX:#006847,#ce1126 MY:#010066,#cc0001 MZ:#007168,#fce100 NA:#003580,#009543
NC:#0055a4,#ef4135 NE:#e05206,#0db02b NF:#00843d,#ffffff NG:#008751,#ffffff NI:#0067c6,#ffffff
NL:#ae1c28,#21468b NO:#ba0c2f,#00205b NP:#dc143c,#003893 NR:#002b7f,#ffc61e NU:#fedd00,#012169
NZ:#012169,#c8102e OM:#db161b,#008000 PA:#da121a,#072357 PE:#d91023,#ffffff PF:#ce1126,#ffffff
PG:#000000,#ce1126 PH:#0038a8,#ce1126 PK:#01411c,#ffffff PL:#ffffff,#dc143c PM:#0055a4,#ef4135
PN:#012169,#ffffff PR:#ed0000,#0050f0 PS:#000000,#009736 PT:#da291c,#046a38 PW:#0099ff,#ffde00
PY:#d52b1e,#0038a8 QA:#8a1538,#ffffff RE:#0055a4,#ef4135 RO:#002b7f,#fcd116 RS:#c6363c,#0c4076
RU:#ffffff,#0039a6 RW:#00a1de,#fad201 SA:#006c35,#ffffff SB:#0051ba,#215b33 SC:#003f87,#fcd856
SD:#d21034,#000000 SE:#006aa7,#fecc00 SG:#ef3340,#ffffff SH:#012169,#ffffff SI:#ffffff,#005da4
SJ:#ba0c2f,#00205b SK:#0b4ea2,#ee1c25 SL:#1eb53a,#0072c6 SM:#5eb6e4,#ffffff SN:#00853f,#fdef42
SO:#4189dd,#ffffff SR:#377e3f,#b40a2d SS:#078930,#da121a ST:#12ad2b,#ffce00 SV:#0f47af,#ffffff
SX:#dc171d,#012a87 SY:#ce1126,#000000 SZ:#3e5eb9,#b10c0c TC:#012169,#ffffff TD:#002664,#fecb00
TF:#002395,#ffffff TG:#006a4e,#ffce00 TH:#2d2a4a,#a51931 TJ:#cc0000,#006600 TK:#00247d,#fed100
TL:#dc241f,#ffc726 TM:#00843d,#d22630 TN:#e70013,#ffffff TO:#c10000,#ffffff TR:#e30a17,#ffffff
TT:#ce1126,#000000 TV:#5b97b1,#ffce00 TW:#fe0000,#000095 TZ:#1eb53a,#00a3dd UA:#0057b7,#ffd700
UG:#000000,#fcdc04 UM:#0a3161,#b31942 US:#0a3161,#b31942 UY:#0038a8,#ffffff UZ:#0099b5,#1eb53a
VA:#ffe000,#ffffff VC:#002674,#009e60 VE:#cf142b,#ffcc00 VG:#012169,#ffffff VI:#ffffff,#f4c300
VN:#da251d,#ffff00 VU:#d21034,#009543 WF:#0055a4,#ef4135 WS:#ce1126,#002b7f XK:#244aa5,#d0a650
YE:#ce1126,#000000 YT:#0055a4,#ef4135 ZA:#007749,#ffb81c ZM:#198a00,#ef7d00 ZW:#006400,#ffd200
`;

export const FLAG_COLORS: Readonly<Record<string, readonly [string, string]>> = Object.freeze(
  Object.fromEntries(
    FLAG_COLORS_RAW.trim()
      .split(/\s+/)
      .map((entry) => {
        const [code, colors] = entry.split(':') as [string, string];
        const [c1, c2] = colors.split(',') as [string, string];
        return [code, [c1, c2] as const];
      })
  )
);

/** Todos los códigos de país, ordenados. */
export const COUNTRY_CODES: readonly string[] = Object.freeze(Object.keys(FLAG_COLORS).sort());

export const isCountryCode = (v: unknown): v is string => typeof v === 'string' && v in FLAG_COLORS;

/** Normaliza un código de país recibido (mayúsculas). `null` = sin país (color personalizado). */
export const sanitizeCountry = (raw: unknown): string | null => {
  if (typeof raw !== 'string') return null;
  const code = raw.trim().toUpperCase();
  return isCountryCode(code) ? code : null;
};

/** Emoji de la bandera (dos letras regionales). */
export const flagEmoji = (code: string): string =>
  isCountryCode(code) ? String.fromCodePoint(...[...code].map((c) => 0x1f1e6 + c.charCodeAt(0) - 65)) : '';

/** Colores del uniforme según la bandera: [principal, secundario]. */
export const countryColors = (code: string | null | undefined): readonly [string, string] | null =>
  code && isCountryCode(code) ? FLAG_COLORS[code]! : null;

// ─────────────────────────────────────────────
// Colores parecidos entre compañeros de equipo
// ─────────────────────────────────────────────

const hexToRgb = (hex: string): [number, number, number] => {
  const n = parseInt(hex.slice(1), 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
};
const rgbToHex = (r: number, g: number, b: number): string =>
  '#' + [r, g, b].map((v) => Math.round(Math.max(0, Math.min(255, v))).toString(16).padStart(2, '0')).join('');

/** Distancia perceptual aproximada entre dos colores (0..~765, "redmean"). */
export const colorDistance = (a: string, b: string): number => {
  const [r1, g1, b1] = hexToRgb(a);
  const [r2, g2, b2] = hexToRgb(b);
  const rm = (r1 + r2) / 2;
  const dr = r1 - r2;
  const dg = g1 - g2;
  const db = b1 - b2;
  return Math.sqrt((2 + rm / 256) * dr * dr + 4 * dg * dg + (2 + (255 - rm) / 256) * db * db);
};

/** Por debajo de esta distancia dos camisetas se confunden en la cancha. */
export const SIMILAR_COLOR = 60;

/**
 * Matiz leve para diferenciar a compañeros con el mismo color: `step` 1, 2, 3…
 * alterna más claro / más oscuro (sin cambiar el tono de la bandera).
 */
export const shadeVariant = (hex: string, step: number): string => {
  if (step <= 0) return hex;
  const [r, g, b] = hexToRgb(hex);
  const amount = 0.18 * Math.ceil(step / 2);
  const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  // Los muy claros solo pueden oscurecerse y los muy oscuros solo aclararse.
  const lighten = lum < 0.25 ? true : lum > 0.8 ? false : step % 2 === 1;
  return lighten
    ? rgbToHex(r + (255 - r) * amount, g + (255 - g) * amount, b + (255 - b) * amount)
    : rgbToHex(r * (1 - amount), g * (1 - amount), b * (1 - amount));
};
